import React, {useEffect} from "react";
import FasterDeliveries from "../../assets/FasterDeliveries.png";
import Operation from "../../assets/Operation.png";
import CostEfficiency from "../../assets/CostEfficiency.png";

const ChoosePackky = () => {
  return (
    <div
      className="container-fluid default-container1 d-flex flex-column justify-content-center align-items-center h-100"
      style={{ backgroundColor: "#ECECEC", minHeight: "100vh" }}
    >
      <div className="container px-3 mb-4">
        <div className="custom card body w-100 h-100 mt-4 p-4 shadow-lg rounded-4">
          <h2 className=" fw-bold text-center mb-3" style={{ color: "#444444",fontSize: "28px" }}>
            Why Choose Packky?
          </h2>
          <h5 className="text-center text-secondary" style={{fontSize: "24px"}}>Logistics built for speed, simplicity, and savings.</h5>
          <div className="row d-flex flex-wrap justify-content-center gap-0 mt-4 align-items-stretch">
            {[
              { img: FasterDeliveries, title: "Faster Deliveries", text: "Smart routing and quick dispatch ensure your parcels reach on time, every time. Speed matters — and we make sure you deliver fast." },
              { img: Operation, title: "Seamless Operations", text: "From booking to delivery, everything runs in sync. Whether you’re sending to stores, customers, or vendors, Packky (powered by Chaafo) keeps it all connected." },
              { img: CostEfficiency, title: "Cost Efficiency", text: "No more fuel waste or idle time. Our platform helps reduce operational costs by matching deliveries to optimized routes and right-sized vehicles." }
            ].map((item, index) => (
              <div key={index} className="col-12 col-md-6 col-lg-4 d-flex mb-4">
                <div className="card border-0 rounded-4 shadow-sm  bg-secondary-subtle p-4 w-100 d-flex flex-column">
                  <div className="text-black d-flex flex-column justify-content-center align-items-center text-center">
                    <img
                      src={item.img}
                      alt={item.title}
                      width="60"
                      height="60"
                      className="rounded-circle bg-white p-1 border border-primary mb-3"
                    />
                    <h5 className="fw-bold fs-4 text-center">{item.title}</h5>
                    <p className="text-secondary fs-6 mt-2">{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChoosePackky;
